import { useRef, useState } from 'react';

export const pageLinks = [
  ['#product', 'The experience'],
  ['#use-cases', 'Use cases'],
  ['#how', 'How it works'],
  ['#studio', 'Studio'],
  ['#gate', 'Your control'],
  ['#safe', 'Questions'],
] as const;

export function TopBar() {
  const [open, setOpen] = useState(false);
  const toggle = useRef<HTMLButtonElement>(null);
  return <div className="topbar" onKeyDown={e => {
    if (e.key === 'Escape' && open) { setOpen(false); toggle.current?.focus(); }
  }} onBlur={e => {
    if (!e.currentTarget.contains(e.relatedTarget as Node | null)) setOpen(false);
  }}><div className="wrap"><header className="top">
    <a className="brand-home" href="#main" aria-label="Persivo home" onClick={() => setOpen(false)}><img src="/persivo-lockup-horizontal.svg" alt="Persivo" /></a>
    <nav className="desktop-navigation" aria-label="Main navigation">
      {pageLinks.map(([href, label]) => <a key={href} href={href}>{label}</a>)}
    </nav>
    <div className="header-actions">
      <a className="header-signin" href="https://studio.persivo.co">Sign in <span aria-hidden="true">↗</span></a>
      <button ref={toggle} type="button" className="mobile-menu-toggle" aria-expanded={open} aria-controls="mobile-navigation" onClick={() => setOpen(!open)}>
        {open ? 'Close' : 'Menu'}<span className={open ? 'menu-lines is-open' : 'menu-lines'} aria-hidden="true"><i/><i/></span>
      </button>
      <a className="header-demo" href="#try" onClick={() => setOpen(false)}>Take a demo <span aria-hidden="true">↗</span></a>
    </div>
  </header></div>
    <nav id="mobile-navigation" className="mobile-navigation" aria-label="Mobile navigation" hidden={!open}>
      <div className="wrap mobile-navigation-inner">
        {pageLinks.map(([href, label]) => <a key={href} href={href} onClick={() => setOpen(false)}>{label}<span aria-hidden="true">↗</span></a>)}
        <a className="mobile-demo" href="#try" onClick={() => setOpen(false)}>Take a demo <span aria-hidden="true">↗</span></a>
        <a className="mobile-pilot" href="#pilot" onClick={() => setOpen(false)}>Request a pilot <span aria-hidden="true">↗</span></a>
      </div>
    </nav>
  </div>;
}
